import { render, staticRenderFns } from "./ExportStudentsInvoices.vue?vue&type=template&id=806c6a04"
import script from "./ExportStudentsInvoices.vue?vue&type=script&lang=ts"
export * from "./ExportStudentsInvoices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports